import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";

class OpisWyjazduGaleria extends PureComponent<any> {
  render() {
    const { gallery } = this.props;
    return (
      <a
        className="OpisWyjazduGaleria_link"
        title={"Zobacz galerię " + gallery.source}
        href={gallery.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {gallery.source}
      </a>
    );
  }
}

export default OpisWyjazduGaleria;
